import { Component } from '@angular/core';

@Component({
  selector: 'onyx-information-list',
  imports: [],
  templateUrl: './onyx-information-list.component.html',
  styleUrl: './onyx-information-list.component.scss',
})
export class OnyxInformationListComponent {}
